// birthdate deve ser no formato aaaa-mm-dd
export const calcAge = (birthdate?: string): number | string => {
  if (!birthdate) return ''
  const age = Math.floor((Date.now() - +new Date(`${birthdate.split('-').join('/')}`)) / 31557600000);
  if (isNaN(age) || age < 0) return '';
  return age;
};
